var options={collapsed:{use:false,blockMenu:true},expanded:{use:false,initial:'open'}};export default options;